import React from 'react';
import { formatDOBFromPim } from '@mummssoftware/utils/formatters';
import { useIntl } from 'react-intl';
import messages from '../PatientHeader/messages';
import { PrintPreviewTextContainer, PrintPreviewHeaderDiv } from './styled-divs/PrintPreviewStyledDivs';
export const PrintPreviewHeader = ({
  patient
}) => {
  const {
    formatMessage
  } = useIntl();

  const getPatientInfo = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", null, `${patient === null || patient === void 0 ? void 0 : patient.firstName} ${patient === null || patient === void 0 ? void 0 : patient.lastName}, `, /*#__PURE__*/React.createElement("span", null, `${formatMessage(messages.dob)}: `), `${patient !== null && patient !== void 0 && patient.dateOfBirth ? formatDOBFromPim(patient.dateOfBirth) : ''}, `, /*#__PURE__*/React.createElement("span", null, `${formatMessage(messages.patient)} #: `), `${patient === null || patient === void 0 ? void 0 : patient.patientNumber}`), /*#__PURE__*/React.createElement("p", null, `${patient === null || patient === void 0 ? void 0 : patient.hospiceName}`));

  return /*#__PURE__*/React.createElement(PrintPreviewHeaderDiv, null, /*#__PURE__*/React.createElement(PrintPreviewTextContainer, null, getPatientInfo()));
};
export default PrintPreviewHeader;